<template>
  <transition name="el-zoom-in-center">
    <el-card class="box-card" style="text-align: left" v-show="add.addshow">
      <div slot="header" class="clearfix">
        <el-row>
          <el-col :span="12">
            <h3>新增原料投料</h3>
          </el-col>
          <el-col :span="12">
            <el-button style="float: right" type="primary" @click="add.addshow = false"
              >收起</el-button
            >
          </el-col>
        </el-row>
      </div>
      <el-form ref="form" :model="form" label-width="110px" :rules="rules">
        <el-row>
          <el-col :span="5" :offset="9">
            <el-form-item label="选择工单" prop="orderno">
              <el-select
                type="text"
                v-model="form.orderno"
                style="width: 100%"
                filterable
                remote
                placeholder="请输入关键词"
                @change="ordernoselect"
                :remote-method="ordernoremoteMethod"
                :loading="loading"
              >
                <el-option
                  v-for="item in ordernolist"
                  :key="item.orderno"
                  :label="item.orderno"
                  :value="item.orderno"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选择原料" prop="material_code">
              <el-select
                type="text"
                v-model="form.material_code"
                style="width: 100%"
                @change="changematerial"
                filterable
                placeholder="请输入名称模糊查询"
                :loading="loading"
              >
                <el-option
                  v-for="item in materiallist"
                  :key="item.material_code"
                  :label="item.material_name"
                  :value="item.material_code"
                >
                  <span style="float: left">{{ item.material_name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    item.material_code
                  }}</span></el-option
                >
              </el-select>
            </el-form-item>
            <el-form-item label="选择供应商" prop="supplier_code">
              <el-select
                type="text"
                v-model="form.supplier_code"
                style="width: 100%"
                @change="changesupplier"
                filterable
                placeholder="请输入名称模糊查询"
              >
                <el-option
                  v-for="item in supplierlist"
                  :key="item.supplier_code"
                  :label="item.supplier_name"
                  :value="item.supplier_code"
                >
                  <span style="float: left">{{ item.supplier_name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    item.supplier_code
                  }}</span></el-option
                >
              </el-select>
            </el-form-item>
            <el-form-item label="原料批次" prop="material_batchno">
              <el-input
                v-model.trim="form.material_batchno"
                style="width: 100%"
              ></el-input>
            </el-form-item>
            <el-form-item label="原料生产商" prop="material_manufacturer">
              <el-input
                v-model.trim="form.material_manufacturer"
                style="width: 100%"
              ></el-input>
            </el-form-item>
            <el-form-item label="原料生产商产地" prop="material_manufacturer_place">
              <el-input
                v-model.trim="form.material_manufacturer_place"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <br />
        <div style="text-align: center">
          <el-button style="margin-top: 12px" @click="resetForm('form')">重置</el-button>
          <el-button style="margin-top: 12px" type="primary" @click="submitadd('form')"
            >提交</el-button
          >
        </div>
      </div>
    </el-card>
  </transition>
</template>

<script>
import {
  MaterialsBatchLogordernolist,
  orderquery,
  MaterialsBatchLogadd,
} from "@/api/plant";
import { supplierlist, materiallist } from "@/api/base"; // 供应商查询 原料查询

export default {
  props: {
    search: {
      type: Function,
      default: null,
    },
    add: {
      type: Object,
      default: () => {
        return {
          addshow: null,
        };
      },
    },
  },
  data() {
    return {
      //基础数据
      show: true,
      loading: false,
      materiallist: [],
      ordernolist: [],
      supplierlist: [],
      storetypelist: [
        {
          value: 2,
          label: "公司仓库",
        },
        {
          value: 3,
          label: "经销商仓库",
        },
      ],
      form: {
        orderno: "",
        product_code: "",
        product_name: "",
        product_batchno: "",
        material_code: "",
        material_name: "",
        material_batchno: "",
        supplier_code: "",
        supplier_name: "",
        create_user: "",
        source: "",
        material_manufacturer: "",
        material_manufacturer_place: "",
      },
      rules: {
        warehouseCode: [
          { required: true, message: "请输入仓库编码", trigger: "blur" },
          { validator: this.$validateaccount, trigger: "blur" },
          { validator: this.ifbianma, trigger: "blur" },
        ],
        warehouseName: [{ required: true, message: "请输入仓库名称", trigger: "blur" }],
        relationDepartCode: [
          { required: true, message: "请选择所属部门", trigger: "blur" },
        ],
        provinceId: [{ required: true, message: "请选择地区", trigger: "blur" }],
      },
    };
  },
  mounted() {
    // 获取生产工单、原料、供应商列表
    MaterialsBatchLogordernolist().then((response) => {
      this.ordernolist = response.data;
    });
    materiallist().then((response) => {
      this.materiallist = response.data;
    });
  },
  methods: {
    // 工单模糊匹配
    ordernoremoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          MaterialsBatchLogordernolist({ orderno: query }).then((response) => {
            this.ordernolist = response.data;
            this.loading = false;
          });
        }, 200);
      } else {
        this.ordernolist = [];
      }
    },
    // 选择工单
    ordernoselect(code) {
      orderquery({ page_index: 1, pageSize: 10, orderNo: code }).then((response) => {
        console.log(response.data.data[0]);
        this.form.product_code = response.data.data[0].product_code;
        this.form.product_name = response.data.data[0].product_name;
        this.form.product_batchno = response.data.data[0].batchno;
      });
    },
    // 选择原料
    changematerial(val) {
      let obj = {};
      obj = this.materiallist.find((item) => {
        return item.material_code === val;
      });
      this.form.material_name = obj.material_name;
      console.log(this.form.material_name);
      supplierlist({ material_code: val }).then((response) => {
        this.supplierlist = response.data;
      });
    },
    // 选择供应商
    changesupplier(val) {
      let obj = {};
      obj = this.supplierlist.find((item) => {
        return item.supplier_code === val;
      });
      console.log(obj);
      this.form.supplier_name = obj.supplier_name;
    },
    //保存提交
    submitadd(formName) {
      this.$refs[formName].validate((valid) => {
        //基础表单验证
        if (valid) {
          MaterialsBatchLogadd(this.form).then((response) => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "添加成功!",
              });
              this.search();
              this.add.addshow = false;
              this.resetForm(formName);
            } else {
              this.$message({
                type: "warning",
                message: "添加失败!请检查字段",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 清空表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style lang="scss" scoped></style>
